<template>
  <div
    class="form"
    :class="{'en-form': isEnglish}"
  >
    <a-form
      v-if="formData"
      :form="form"
    >
      <div
        v-for="(modules, k) in formData"
        :key="k"
        :data-key="modules.fieldkey"
      >
        <!-- v-show="modules.fieldkey !== 'deal_info' || (modules.fieldkey === 'deal_info' && modules.show)" -->
        <!-- 人员信息 没有线索部分 -->
        <div
          v-if="modules && !(modules.fieldkey === 'from_info' || modules.fieldkey === 'reception_info' || modules.fieldkey === 'info')"
          :id="`anchor_${modules.fieldkey}`"
          class="module"
          :class="{ 'hide': hideModule(k) }"
        >
          <h2
            class="title"
          >
            {{ modules.fieldname }}
          </h2>
          <!-- 表单循环的主题部分 start -->
          <my-item
            v-for="(item) in modules.child"
            v-show="item.fieldtype || modules.fieldkey !== 'info'"
            :id="item.fieldkey"
            :key="item.fieldkey"
            class="clearfix"
            :data="item"
            :modules-data="modules"
            @change="handleChangeItem($event, item)"
          />
          <!-- 表单循环的主题部分 end -->
        </div>
      </div>
      <!-- 信息来源部分特殊处理 start -->
      <div
        v-if="fromInfo"
        id="anchor_from_info"
        class="module from-info"
      >
        <h2
          class="title"
        >
          {{ fromInfo.fieldname }}
        </h2>
        <my-item
          v-if="formData['reception_info'] && formData['reception_info'].child && formData['reception_info'].child.length"
          :data="formData['reception_info'].child[0]"
          class="reception-info"
        />
        <template v-if="fromInfo">
          <my-item
            :value="currentFrom"
            :data="fromInfo"
            @change="handleChangeFromSource"
          />
          <template v-if="currentFrom">
            <my-item
              v-for="(item) in fromInfo.childObj && fromInfo.childObj[currentFrom] && fromInfo.childObj[currentFrom].child"
              :id="item.fieldkey"
              :key="item.fieldkey"
              class="clearfix"
              :data="item"
              :modules-data="fromInfo"
              :current-from="currentFrom"
            />
          </template>
        </template>
      </div>
      <!-- 信息来源部分特殊处理 end -->
      <!-- <div
        v-if="formData.info && isClue"
        class="module member-info info clue-info"
      >
        <h2
          class="title"
        >
          {{ formData.info.fieldname }}
        </h2>
        <member-edit
          :data="formData.info"
          @change="handleChangeMember"
        />
      </div> -->
      <!-- 人员信息 没有线索部分 -->
      <div
        v-if="formData.info "
        id="anchor_info"
        class="module member-info info"
      >
        <h2
          class="title"
        >
          {{ formData.info.fieldname }}
        </h2>
        <member-edit
          :data="formData.info"
          @change="handleChangeMember"
        />
      </div>
    </a-form>
    <!-- 表单按钮 start -->
    <div class="footer-wrap">
      <div
        ref="footer"
        class="footer clearfix"
      >
        <a-button
          type="primary"
          html-type="submit"
          :loading="confirmLoading"
          @click="handleSubmit"
        >
          {{ $t('message["21"]') }}
        </a-button>
        <a-button
          ref="cancelBtn"
          @click="handleCancel"
        >
          {{ $t('message["896"]') }}
        </a-button>
        <!--  -->
        <div
          v-if="permissionInfo.is_show_compare"
          class="format-history"
        >
          <span class="prompt-text">{{ $t('message["344"]') }}</span>
          <a-button
            ref="formatHistoryBtn"
            class="format-history-btn"
            @click="handleFormatHistory"
          >
            {{ $t('message["88"]') }}
          </a-button>
        </div>
      </div>
    </div>
    <!-- 表单按钮 end -->
    <repeat-modal
      :visible.sync="showRepeatModal"
      :data="repeatData"
      :again-save-form="againSaveForm"
    />
    <format-history-modal
      v-if="permissionInfo.is_show_compare"
      :visible.sync="showFormatHistoryModal"
      :form-history-id="formHistoryId"
    />
    <gallery />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { addInquiry } from '@/services/inqueryServices'
import { subClueData } from '@/services/clue'
import MyItem from './../formItem/Item'
import MemberEdit from './MemberEdit'
import RepeatModal from './../detail/modal/RepeatModal'
import FormatHistoryModal from './../detail/modal/FormatHistoryModal'
import Gallery from '@/components/pc/Gallery'
import inquiryFormMixin from '@/lib/inquiryFormMixin'
import eventBus from '@/lib/eventBus'
import { getLang } from '@/lib/storage'

export default {
  components: {
    MyItem,
    // MySelect,
    MemberEdit,
    RepeatModal,
    FormatHistoryModal,
    Gallery
  },
  mixins: [inquiryFormMixin],

  provide () {
    return {
      myForm: this.form
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    setTabIndex: {
      type: Function,
      default: () => ({})
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      formData: Object.assign({}, this.data),
      currentFrom: '',
      showSuccessModal: false,
      showRepeatModal: false,
      repeatData: [],
      confirmLoading: false,
      // 查看提交记录
      showFormatHistoryModal: false
    }
  },
  computed: {
    ...mapState('inquery/detailData', ['formError']),
    ...mapGetters('inquery/addConfigData', ['permissionInfo', 'isNeedAudit']),
    fromInfo () {
      const { from_info: fromInfo = {} } = this.formData || {}

      return fromInfo
    },
    checkrepeatfieldkey () {
      return this.$route.query.checkrepeatfieldkey
    },
    checkrepeatfieldvalue () {
      return this.$route.query.checkrepeatfieldvalue
    },
    formHistoryId () {
      return this.$route.query.form_history_id
    },
    upgradeTipTxt () {
      return this.$t('message["600"]').split('|')
    },
    isEnglish () {
      return this.getLang() === 'en'
    },
    isClue () {
      return this.$route.name === 'ClueCreate'
    },
    clueId () {
      const { clue_id: id = '' } = this.$route.query
      return id
    }
  },

  created () {
    // 设置来源的默认值和默认请求关联接口
    this.initFromInfo()

    // 默认填充查重过来的值
    this.fillCheckRepeatValue()
  },
  methods: {
    ...mapActions('inquery/relateData', ['fetchRelateTeamInfo']),
    getLang,

    hideModule (k) {
      let { isDeal, isInvalid, isDiscard } = this
      let res = false
      switch (k) {
        case 'deal_info':
          res = !isDeal
          break
        case 'invalid_info':
          res = !isInvalid
          break
        case 'discard_info':
          res = !isDiscard
          break
      }
      return res
    },

    handleChangeFromSource (val) {
      if (!this.formData || !this.formData.from_info) return

      this.formData.from_info.fieldvalue = val
      this.currentFrom = val
      this.$forceUpdate()

      // if (!this.isClue) {
      //   this.relateTeamInfo(this.formData.from_info)
      // }
      this.relateTeamInfo(this.formData.from_info)
    },

    fillCheckRepeatValue () {
      if (this.checkrepeatfieldkey && this.checkrepeatfieldvalue) {
        for (let k in this.formData) {
          let modules = this.formData[k]
          let { child = [] } = modules
          for (let item of child) {
            if (item.fieldkey === this.checkrepeatfieldkey) {
              if (item.fieldtype === 'phone' || item.fieldtype === 'email') {
                item.fieldvalue = this.checkrepeatfieldvalue && this.checkrepeatfieldvalue.split(/[,，\s]+/)
              } else {
                item.fieldvalue = this.checkrepeatfieldvalue
              }
            }
          }
        }
      }
    },
    againSaveForm ({ checkrepeatconfirm }) {
      this.handleSubmit(checkrepeatconfirm)
    },

    async handleSubmit (checkrepeatconfirm) {
      this.$bus.$emit('myQuillEditorBlur')

      this.form.validateFields(async (err, values) => {
        err = this.checkError(err)

        if (!err) {
          if (this.confirmLoading) return

          this.confirmLoading = true
          const formData = await this.setFormDataParams(this.formData)
          if (checkrepeatconfirm === 1) {
            formData.checkrepeatconfirm = checkrepeatconfirm
          }
          if (this.formHistoryId) {
            formData.info.form_history_id = this.formHistoryId
          }
          if (this.clueId) {
            formData.info.clue_id = this.clueId
          }

          this.confirmInquiry(formData)
        }
      })
    },
    async confirmInquiry (formData) {
      let _this = this
      let chain = this.isClue ? await subClueData() : await addInquiry()
      chain
        .onSuccess(res => {
          // console.log(res)
          this.confirmSuccess()

          setTimeout(() => {
            this.form.resetFields()
          }, 1000)
        })
        .onNetSuccess(raw => {
          this.confirmLoading = false
          const res = raw.data
          if (res.error === 104) { // 有重复
            this.showRepeatModal = true
            this.repeatData = res.payload
          }
        })
        .config({
          error104: false,
          tip: false,
          error100 (raw) {
            // TODO: 处理后端错误
            let msg = ''
            if (raw.message) {
              msg = raw.message
            } else if (raw.payload && raw.payload.length) {
              msg = raw.payload[0]
            }
            _this.$message.destroy()
            _this.$message.error(msg)
          },
          error105 (raw) {
            // TODO: 处理后端错误
            let msg = ''
            if (raw.message) {
              msg = raw.message
            } else if (raw.payload && raw.payload.length) {
              msg = raw.payload[0]
            }

            let { system_role: systemRole } = _this.$store.state.baseinfo
            _this.$confirm({
              type: 'error',
              title: _this.$t('message["1377"]'),
              content: msg,
              closable: false,
              width: 425,
              centered: true,
              iconType: 'exclamation-circle',
              okText: systemRole === 1 ? _this.upgradeTipTxt[0] : _this.upgradeTipTxt[1],
              cancelText: '',
              class: 'confirm-warn-modal create-inquery-upperlimit-modal',
              onOk: () => {
                if (systemRole === 1) {
                  _this.$router.push({
                    name: 'ServiceIndex'
                  })
                }
              }
            })
          }
        })
        .params(formData)
        .fetch()
    },
    confirmSuccess () {
      let content = ''
      if (this.isNeedAudit) {
        content = this.$t('message["167"]')
      } else {
        content = ''
      }
      this.$confirm({
        type: 'success',
        title: this.$t('message["618"]'),
        content,
        okText: this.$t('message["1712"]'),
        okType: 'primary',
        cancelText: this.$t('message["284"]'),
        iconType: 'check-circle',
        centered: true,
        class: 'confirm-success-modal create-inquery-success-modal',
        width: 364,
        onOk: () => {
          if (this.formHistoryId) {
            this.$router.push({
              name: 'InqueryCreate',
              query: {
                'form_history_id': 0
              }
            })
          }
          if (this.isClue) {
            this.$router.push({
              name: 'ClueCreate'
            })
          }
          if (this.clueId && this.$route.name === 'InqueryCreate' && this.$route.query.from === 'clue') {
            this.$router.push({
              name: 'InqueryCreate'
            })
          }

          location.reload()
        },
        onCancel: () => {
          this.goBackList()
        }
      })
    },
    handleCancel () {
      this.confirmLoading = false
      eventBus.$emit('fetchAddConfig')
      setTimeout(() => {
        eventBus.$emit('clearCascaders', 'dev')
        eventBus.$emit('clearCascaders', 'group')
      }, 1000)
    },
    goBackList () {
      // this.$router.push({
      //   name: 'InqueryList',
      //   query: {
      //     from: 'my',
      //     type: 'inquiry-add'
      //   }
      // })
      const routerName = this.isClue ? 'InqueryClue' : 'InqueryList'
      const queryarg = !this.isClue ? {
        from: 'my',
        type: 'inquiry-add'
      } : {}
      this.$router.push({
        name: routerName,
        query: queryarg
      })
    },
    // 查看提交记录
    handleFormatHistory () {
      this.showFormatHistoryModal = true
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  margin-top: 24px;
  .module {
    padding-bottom: 40px;
    border-top: solid 1px $gray4;
  }
  .clue-info {
    border-top: none;
    padding-bottom: 20px

  }
  .reception-info {
    padding-bottom: 24px;
    border-bottom: solid 1px #ebebeb;
  }
  .footer-wrap {
    height: 64px;
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 998;
    height: 64px;
    margin-left: -40px;
    padding: 16px 0 16px 180px;
    background-color: #fff;
    border-top: solid 1px $gray4;
    .format-history {
      float: right;
      margin-right: 24px;

      .prompt-text {
        color: #f6a953;
        font-size: 14px;
      }
    }
    .format-history-btn {
      margin-left: 20px;
    }
  }
}
.en-form::v-deep {
  .ant-form-item-label {
    width: 200px;
    text-overflow: ellipsis;
    label {
      white-space: nowrap;
    }
  }
  .ant-form-item-control-wrapper {
    padding-left: 200px;
  }
   .ant-form-item-label label::after{
    content: '';
  }
  .ant-form-item-label::after {
    content: ':';
    position: absolute;
    left: 182px;
    top: 0;
    color: #666;
  }
}
</style>
<style lang="scss">
.create-inquery-success-modal {
  .ant-modal-body {
    padding: 32px;
  }
}
</style>
